import { render, staticRenderFns } from "./RelatorioNotas.vue?vue&type=template&id=15cf3319&scoped=true&"
import script from "./RelatorioNotas.vue?vue&type=script&lang=js&"
export * from "./RelatorioNotas.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioNotas.vue?vue&type=style&index=0&id=15cf3319&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf3319",
  null
  
)

export default component.exports